import React, { useState, useEffect } from 'react';

import { nomadLocations } from '../../../copy/locations';

import './NomadMap.css';

export function NomadMap() {
  const [hovered, setHovered] = useState(null);
  const [aspectRatio, setAspectRatio] = useState(null);

  useEffect(() => {
    const img = new Image();
    img.src = '/nomad-map-bg.jpg';
    img.onload = () => {
      const ratio = img.width / img.height;
      setAspectRatio(ratio);
    };
  }, []);

  return (
    <div
      className="nomadMap"
      style={
        aspectRatio
          ? {
              '--aspect-ratio': aspectRatio,
              aspectRatio: aspectRatio,
            }
          : {}
      }
    >
      <div className="nomadMap-header">Where I&apos;ve been</div>
      <div
        className="nomadMap-bg"
        style={{
          backgroundImage: "url('/nomad-map-bg.jpg')",
        }}
      />

      <svg className="nomadMap-constellations">
        {nomadLocations.map((location, index) => {
          const next = nomadLocations[index + 1];

          if (!next) return null;

          return (
            <line
              key={`${location.id}-${next.id}`}
              x1={`${location.x}%`}
              y1={`${location.y}%`}
              x2={`${next.x}%`}
              y2={`${next.y}%`}
              className="nomadMap-line"
            />
          );
        })}
      </svg>

      {nomadLocations.map((location, index) => (
        <button
          key={location.id}
          type="button"
          className="nomadMap-orb"
          style={{
            left: `${location.x}%`,
            top: `${location.y}%`,
            '--orb-color': location.accent,
            '--orb-index': index,
          }}
          onMouseEnter={() => setHovered(location)}
          onMouseLeave={() =>
            setHovered(prev => (prev && prev.id === location.id ? null : prev))
          }
          onFocus={() => setHovered(location)}
          onBlur={() =>
            setHovered(prev => (prev && prev.id === location.id ? null : prev))
          }
          aria-label={location.label}
        >
          <span className="nomadMap-orbInner" />
        </button>
      ))}

      {hovered && (
        <div
          className="nomadMap-tooltip"
          style={{
            left: `${hovered.x}%`,
            top: `${hovered.y}%`,
          }}
        >
          <div className="nomadMap-tooltipTitle">{hovered.label}</div>
          {hovered.subtitle && (
            <div className="nomadMap-tooltipSubtitle">{hovered.subtitle}</div>
          )}
        </div>
      )}
    </div>
  );
}

export default NomadMap;
